// extracted by mini-css-extract-plugin
export default {"container":"PhoneNumberInput_container__HD9EY","phoneNumberInput":"PhoneNumberInput_phoneNumberInput__a8Q3E"};